jQuery(document).ready(function() {
	// mehr anzeigen fuer Produktbeschreibung
	if (jQuery('.u-Product-desc').height() >= 250)
	{
		jQuery(".u-Product-desc").addClass('is--toHeight');
		jQuery('#u-Product-main--descMore').css("display","block");
		jQuery('#u-Product-main--descLess').css("display","none");
		
		jQuery('#u-Product-main--descMore').click(function() {
			jQuery(".u-Product-desc").css("height","auto").addClass('no--after');
			jQuery('#u-Product-main--descMore').css("display","none");
			jQuery('#u-Product-main--descLess').css("display","block");
		});

		jQuery('#u-Product-main--descLess').click(function() {
			jQuery(".u-Product-desc").css("height","250px").removeClass('no--after');
			jQuery('#u-Product-main--descMore').css("display","block");
			jQuery('#u-Product-main--descLess').css("display","none");
		});
	}

	// hamburger menue icon
	$('button.hamburger').click(function() {
		$('button.hamburger').toggleClass("is-active");
	});
	
	// same height -> u-Product-pricetable ---
	$('.u-ProductPrice-table--equalheight, .u-Product-actions--equalheight, .u-equal--height').matchHeight();
});
